import { MIMETypes } from 'constants/mime-types';

export const getMimeType = (ext: string) => MIMETypes[ext?.toLowerCase()] || '';
